import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'
import {remCalc} from '../../_utils'

const helpers = createMultiStyleConfigHelpers([
    'container',
    'title',
    'containerBreakpoint',
    'image',
    'titleBreakpoint',
])

export const createGradientBackground = (imageUrl: string) => ({
    background: `
    linear-gradient(180deg, rgba(0, 0, 0, 0.00) 55%, rgba(0, 0, 0, 0.60) 84.62%), 
    url(${imageUrl}) center / cover no-repeat
  `,
})

const ListMenuCard = helpers.defineMultiStyleConfig({
    baseStyle: {
        container: {
            borderRadius: 'large',
            boxShadow: `
  0px 6px 12px oklch(22.61% 0.0654 273.71 / 0.16),
  0px 2px 4px oklch(22.61% 0.0654 273.71 / 0.06)
`,
            bg: 'white',
        },
        title: {textDecoration: 'none'},
        image: {
            overflow: 'hidden',
        },
        // img: {
        //     height: '100%',
        // },
    },
    variants: {
        default: {
            container: {
                w: {lg: remCalc(213)},
                h: {base: remCalc(120), lg: remCalc(134)},
                px: remCalc(16),
                pt: {base: remCalc(12), lg: remCalc(16)},
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                pb: 0,
            },
            containerBreakpoint: {
                '@media (min-width: 1024px) and (max-width: 1200px)': {
                    w: '100%',
                    h: remCalc(120),
                    pt: remCalc(12),
                },
                '@media (min-width: 1200px) and (max-width: 1400px)': {
                    w: remCalc(190),
                },
            },
            title: {
                textStyle: {base: 'body-small', lg: 'body-large'},
                color: 'text.primary',
                fontWeight: 'bold',
            },
            titleBreakpoint: {
                '@media (min-width: 1024px) and (max-width: 1200px)': {
                    textStyle: 'body-small',
                },
            },
            image: {
                w: remCalc(75),
                h: remCalc(75),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                ml: 'auto',
            },
        },
        filter: {
            container: {
                w: {lg: remCalc(174)},
                h: {base: remCalc(110), md: remCalc(130), lg: remCalc(134)},
                pos: 'relative',
                overflow: 'hidden',
            },
            containerBreakpoint: {
                '@media (min-width: 1024px) and (max-width: 1200px)': {
                    w: '100%',
                    h: remCalc(130),
                },
            },
            title: {
                textStyle: 'body-small',
                pos: 'absolute',
                bottom: {base: remCalc(14), lg: remCalc(10)},
                px: remCalc(10),
                color: 'text.inverse',
                textAlign: 'center',
                w: '100%',
            },
            titleBreakpoint: {
                '@media (min-width: 1024px) and (max-width: 1200px)': {
                    bottom: remCalc(14),
                },
            },
            image: {
                h: '100%',
                w: '100%',
            },
        },
        filterIcon: {
            container: {
                w: {lg: remCalc(174)},
                h: {base: remCalc(110), md: remCalc(130), lg: remCalc(134)},
                pos: 'relative',
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                gap: remCalc(20),
                alignItems: 'center',
                flexDirection: 'column-reverse',
            },
            containerBreakpoint: {
                '@media (min-width: 1024px) and (max-width: 1200px)': {
                    w: '100%',
                    h: remCalc(130),
                },
            },
            title: {
                textStyle: 'body-small',
                textAlign: 'center',
                w: '100%',
            },
            titleBreakpoint: {
                '@media (min-width: 1024px) and (max-width: 1200px)': {
                    bottom: remCalc(14),
                },
            },
            image: {h: remCalc(40), w: remCalc(40)},
        },
        promo: {
            container: {
                w: {base: '100%', lg: remCalc(332)},
                h: remCalc(160),
                pos: 'relative',
                overflow: 'hidden',
            },
            containerBreakpoint: {
                '@media (min-width: 1024px) and (max-width: 1200px)': {
                    w: '100%',
                },
                '@media (min-width: 1200px) and (max-width: 1400px)': {
                    w: remCalc(300),
                },
            },
            title: {
                textStyle: {base: 'body-small', lg: 'body-large'},
                pos: 'absolute',
                bottom: remCalc(14),
                px: remCalc(10),
                color: 'text.inverse',
                textAlign: 'center',
                w: '100%',
            },
            titleBreakpoint: {
                '@media (min-width: 1024px) and (max-width: 1200px)': {
                    textStyle: 'body-small',
                },
            },
            image: {
                h: '100%',
                w: '100%',
            },
        },
        secondary: {
            container: {
                height: remCalc(62),
                px: remCalc(15),
                py: remCalc(10),
                display: 'flex',
                flexDirection: 'row-reverse',
                justifyContent: 'flex-end',
                alignItems: 'center',
                boxShadow: `
  0px 6px 12px oklch(22.61% 0.0654 273.71 / 0.16),
  0px 2px 4px oklch(22.61% 0.0654 273.71 / 0.06)
`,
                gap: remCalc(12),
                borderRadius: 'large',
            },
            title: {
                textDecoration: 'none',
                fontWeight: 'bold',
                textStyle: 'body-small',
                color: 'text.primary',
            },
            image: {
                h: remCalc(36),
                w: remCalc(36),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                rounded: 'full',
            },
        },
        simpleLink: {
            container: {
                w: {base: '100%'},
                h: remCalc(120),
                pos: 'relative',
                overflow: 'hidden',
            },
            title: {
                textStyle: 'body-small',
                pos: 'absolute',
                fontWeight: 'bold',
                left: remCalc(16),
                top: remCalc(12),
                color: 'text.inverse',
                textAlign: 'center',
            },
            image: {h: '100%', w: '100%'},
        },
    },
})

export default ListMenuCard
